import {Stack} from 'immutable';
import {UNHANDLED_ERROR} from '../actions';

export function unhandledError(state = null, action) {
  let nextState = state || Stack();

  if (action.type === UNHANDLED_ERROR) {
    nextState = nextState.push(action.error);
  }

  return nextState;
}



// WEBPACK FOOTER //
// ./app/javascript/reducers/logging.js